import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getAnnouncements: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/announcements`
    },
    createAnnouncement: {
        method: 'POST',
        url: `${BASE_PATH_API}/communication/announcements`
    },
    getAnnouncement: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/announcements/:id`
    },
    updateAnnouncement: {
        method: 'PUT',
        url: `${BASE_PATH_API}/communication/announcements/:id`
    },
    getAllAnnouncements: {
        method: 'GET',
        url: `${BASE_PATH_API}/announcements`,
        params: {
            '$count': true
        }
    },
    getSmsDeliverySettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/announcements/smsDeliverySettings`
    },
    updateSmsDeliverySettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/announcements/smsDeliverySettings`
    },
    getTemplates: {
        method: 'GET',
        cache: true,
        url: `${BASE_PATH_API}/announcements/templates`
    }
};

export function AnnouncementApi(
    $httpParamSerializer
) {
    const service = createActions(actions);

    service.getAnnouncementsExportUrl = function getAnnouncementsExportUrl(params) {
        return `${BASE_PATH_API}/announcements/export?${$httpParamSerializer(params)}`;
    };

    service.getAnnouncementsNewExportUrl = function getAnnouncementsNewExportUrl(params) {
        return `${BASE_PATH_API}/communication/announcements/export?${$httpParamSerializer(params)}`;
    };

    return service;
}
AnnouncementApi.$inject = [
    '$httpParamSerializer'
];
